import React from 'react';

export const JESSICA_AVATAR_SRC = `${process.env.PUBLIC_URL || ''}/jessica-avatar.png`;

export default function JessicaAvatar({ size = 'md', className = '', ring = false }) {
  const sizes = {
    xs: 'h-5 w-5',
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-14 w-14',
  };
  const sizeClass = sizes[size] || sizes.md;

  return (
    <span
      className={`relative inline-flex shrink-0 overflow-hidden rounded-full ${sizeClass} ${
        ring ? 'ring-2 ring-amber-400/60 ring-offset-2 ring-offset-[#0d0d14]' : ''
      } ${className}`}
      aria-hidden
    >
      <img
        src={JESSICA_AVATAR_SRC}
        alt=""
        className="h-full w-full object-cover object-[center_20%]"
        loading="lazy"
        decoding="async"
      />
    </span>
  );
}
